import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const OpinionsIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع اراء العملاء",
				breadcrumb: "اراء العملاء",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة رأي جديد",
					link: "/opinions/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/opinions/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			{data.map(item =>
				item.categories.map(category => (
					<div key={category.id}>
						{category.posts.map(post => (
							<div key={post.id}>
								{post.data.opinions.map(opinion => (
									<div className="opinion" key={opinion.name}>
										<Link
											to={
												checkPermissions(["post-edit"])
													? `/opinions/show/${post.id}`
													: "/"
											}
										>
											{opinion.name} - {opinion.position}
										</Link>
										{checkPermissions(["post-delete"]) && (
											<button onClick={() => handleDelete(post.id)}>
												<i className="fas fa-trash"></i>
											</button>
										)}
									</div>
								))}
							</div>
						))}
					</div>
				))
			)}
		</section>
	);
};

export default OpinionsIndex;
